import { render, staticRenderFns } from "./Vizyon.vue?vue&type=template&id=2b8e5439&scoped=true&"
import script from "./Vizyon.vue?vue&type=script&lang=js&"
export * from "./Vizyon.vue?vue&type=script&lang=js&"
import style0 from "./Vizyon.vue?vue&type=style&index=0&id=2b8e5439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e5439",
  null
  
)

export default component.exports